import { render } from "./StatsWithTrending.vue?vue&type=template&id=6c572615"
import script from "./StatsWithTrending.vue?vue&type=script&lang=js"
export * from "./StatsWithTrending.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__